import {
  TextInput,
  required,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  SelectInput,
  BooleanInput,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceInput
          source="parentId"
          reference={administrationRequests.getDisciplinesSelect()}
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="name"
            label="Главна дисциплина"
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <ReferenceArrayInput
          source="departmentIds"
          reference={administrationRequests.getDepartmentsSelect()}
          filter={{ filterByUser: true }}
        >
          <AutocompleteArrayInput
            optionText="name"
            label="Катедри"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>

      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <SelectInput
          source="category"
          label="Категория"
          choices={[
            { id: 1, name: "Основна" },
            { id: 2, name: "Спорт" },
            { id: 3, name: "Чужд език" },
          ]}
          optionText="name"
          optionValue="id"
        />
      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <BooleanInput
          label="Може да се запише условно"
          source={"isRequiredForAdvance"}
          defaultValue={false}
        />
      </Grid>
      <Grid
        item
        md={6}
        sm={6}
        xs={12}
      >
        <BooleanInput
          label="Има практически изпит"
          source="hasPracticalExam"
          defaultValue={false}
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
